export default {
    es: {
        dashboard: 'Tablero',
        users: 'Usuarios',
        name: 'Nombre',
        created: 'Creado',
        createdBy: 'Creado por',
        share: 'Compartir',
        edit: 'Editar',
        delete: 'Eliminar',
        modified: 'Modificado',
        newDashboard: 'Nuevo tablero',
        ascendingOrder: 'Orden ascendente',
        descendingOrder: 'Orden descendente',
        startDate: 'Fecha inicial',
        endDate: 'Fecha final',
        sintaxisError: 'Error de sintaxis',
        pickDate: 'Selecciona la(s) fecha(s)',
        clearFilters: 'Borrar filtros',
        common: {
            backToLogin: "Volver al inicio de sesión",
            cancel: "Cancelar",
            save: "Guardar",
            edit: "Editar",
            create: "Crear",
            skip: "Omitir",
            next: "Siguiente",
            continue: "Continuar",
            refresh: "Actualizar",
            sending: "Enviando...",
            saving: "Guardando...",
            loading: "Cargando...",
            unexpectedError: "Ocurrió un error inesperado. Por favor contacta al soporte.",
        },
    },
    en: {
        dashboard: 'Dashboard',
        users: 'Users',
        name: 'Name',
        created: 'Created',
        createdBy: 'Created by',
        share: 'Share',
        edit: 'Edit',
        delete: 'Delete',
        modified: 'Modified',
        newDashboard: 'New dashboard',
        ascendingOrder: 'Ascending order',
        descendingOrder: 'Descending order',
        startDate: 'Start date',
        endDate: 'End date',
        sintaxisError: 'Sintaxis error',
        pickDate: 'Pick (a) date(s)',
        clearFilters: 'Clear filters',
        common: {
            backToLogin: "Back to Login",
            cancel: "Cancel",
            save: "Save",
            edit: "Edit",
            create: "Create",
            skip: "Skip",
            next: "Next",
            continue: "Continue",
            refresh: "Refresh",
            sending: "Sending...",
            saving: "Saving...",
            loading: "Loading...",
            unexpectedError: "Unexpected error occurred. Please contact support.",
        },
    },
}
